<div style="background: #ffeeff" class="h-100 overflow-auto crm-scroll">
  <app-sidebar-header (close)="close.emit()" [title]="('integration' | translate) + ' OLX'"></app-sidebar-header>
  <mat-card style="" class="shadow-none bg-transparent">
    <mat-card-header class="d-flex flex-column bg-white rounded-2 m-3 p-4">
      <div class="d-flex flex-column bg-white rounded-2">
        <div class="d-flex flex-wrap gap-4">
          <div class="icon-logo"><img src="/assets/svgs/integrations/olx_off_color.svg" alt="Olx logo" /></div>
          <div>
            <h5>{{ 'log_in_with_your_OLX_account' | translate }}</h5>
            <p>{{ 'channel' | translate }}: {{ channel_name }}</p>
            <p>
              {{ 'status' | translate }}:
              @if (CHANNEL_STATUS_OBJECT[status]) {
                <span class="badge" [ngStyle]="{ 'background-color': CHANNEL_STATUS_OBJECT[status].color }">
                  {{ 'channel_status_new.' + CHANNEL_STATUS_OBJECT[status].textKey | translate }}
                </span>
              }
            </p>
            @if (!isLoader && !is_pause && baseService.currentCompanyInfo.config?.is_olx_connect) {
              <div class="d-flex gap-2 flex-wrap">
                @switch (status) {
                  @case (CHANNEL_STATUS.CREATED) {
                    <app-button (onChangeClick)="connectAccount()">{{ 'connect' | translate }}</app-button>
                    <app-button btnType="stroked" (onChangeClick)="deleteChannel()">{{
                      'delete' | translate
                    }}</app-button>
                  }
                  @case (CHANNEL_STATUS.CONNECTED) {
                    <app-button btnType="stroked" (onChangeClick)="disconnectAccount()">{{
                      'disable' | translate
                    }}</app-button>
                  }
                  @case (CHANNEL_STATUS.SYNCING) {
                    <app-button btnType="stroked" (onChangeClick)="disconnectAccount()">
                      {{ 'disable' | translate }}
                    </app-button>
                  }
                  @case (CHANNEL_STATUS.EXPIRED) {
                    <app-button btnType="stroked" (onChangeClick)="refreshAccount()">{{
                      'reconnect' | translate
                    }}</app-button>
                    <app-button btnType="stroked" (onChangeClick)="disconnectAccount()">{{
                      'disable' | translate
                    }}</app-button>
                  }
                  @case (CHANNEL_STATUS.CLOSED) {
                    <app-button btnType="stroked" (onChangeClick)="refreshAccount()">{{
                      'reconnect' | translate
                    }}</app-button>
                  }
                  @default {
                    <!--                  <app-button (onChangeClick)="connectAccount()">{{'connect' | translate}}</app-button>-->
                    <!--                  <app-button btnType="stroked" (onChangeClick)="deleteChannel()">{{'delete'| translate}}</app-button>-->
                  }
                }
              </div>
            }
          </div>
        </div>
      </div>
    </mat-card-header>
    @if (is_empty) {
      <mat-card-content class="m-3 p-4 bg-white rounded-2">
        <h5>{{ 'instructions_for_obtaining_account_data' | translate }}:</h5>
        <ol>
          <li>{{ 'pen_the_browser_in_which_you_log_in_to_the_OLX_account_you_need' | translate }}.</li>
          <li>{{ 'Log_in_to_your_OLX_account_in_this_browser' | translate }}.</li>
          <li>
            {{ 'in_a_new_tab,_go_to' | translate }} {{ NAME_PROJECT }} ({{ environment.web_url }})
            {{ 'using_your_credentials' | translate }}.
          </li>
          <li>{{ 'in_the_account_connection_tab,_click_the_button' | translate }} "{{ 'connect' | translate }}".</li>
          <li>
            {{ 'a_new_window_will_appear_in_which' | translate }} {{ NAME_PROJECT }}
            {{ 'you_need_to_grant_access_to_your_OLX_account.' | translate }}. {{ 'click_the_button' | translate }} "{{
              'allow' | translate
            }}".
          </li>
        </ol>
        <div>{{ 'account_connected_messenger' | translate }} {{ NAME_PROJECT }} {{ 'on_any_device' | translate }}.</div>
      </mat-card-content>
    }
    @if (!is_empty || isLoader) {
      <mat-card-content class="m-3 p-4 bg-white rounded-2">
        <h5>{{ 'information' | translate }}</h5>
        <mat-divider class="mb-3"></mat-divider>
        @if (isLoader) {
          <div class="d-flex justify-content-center">
            <app-loader size="small"></app-loader>
          </div>
        } @else {
          @if (channel) {
            <div>
              <p class="text-secondary">
                ID {{ 'user' | translate }}: <span class="text-dark">{{ account.id || channel.x_data?.user_id }}</span>
              </p>
              <p class="text-secondary">
                Email {{ 'user' | translate }}:
                <span class="text-dark">{{ account.email || channel.x_data?.user_email }}</span>
              </p>
              <p class="text-secondary">
                Phone Login {{ 'user' | translate }}:
                <span class="text-dark">{{ account.phone_login || channel.x_data?.user_phone_login }}</span>
              </p>
              <p class="text-secondary">
                Phone {{ 'user' | translate }}:
                <span class="text-dark">{{ account.phone || channel.x_data?.user_phone }}</span>
              </p>
              <p class="text-secondary">
                {{ 'business_account' | translate }}?:
                <span class="text-dark">{{
                  account.is_business || channel.x_data?.user_is_business ? 'yes' : ('no' | translate)
                }}</span>
              </p>
              <p class="text-secondary">
                {{ 'domain' | translate }}:
                <span class="text-info text-decoration-underline"><a href="https://olx.ua">https://olx.ua</a></span>
              </p>
              <p class="text-secondary">
                {{ 'token' | translate }}: <span class="text-dark">{{ channel.x_data?.access_token }}</span>
              </p>
            </div>
          }
        }
      </mat-card-content>
    }

    <!--    <mat-card-content class="m-3 p-4 bg-white rounded-2" *ngIf="formReply" [formGroup]="formReply">-->
    <!--      <div class="d-flex flex-column" formArrayName="replies">-->
    <!--        <div>-->
    <!--          <div class="d-flex flex-column" *ngFor="let replyParams of getReplyParams().controls; let iParams = index" [formGroupName]="iParams" >-->
    <!--                <div class="d-flex flex-column" *ngIf="getReplyParams().length">-->
    <!--                  <div>-->
    <!--                    <h5>{{'auto_reply_to_the_first_message' | translate}}</h5>-->
    <!--                  </div>-->
    <!--                  <div class="d-flex justify-content-around gap-2 align-items-center" >-->
    <!--                    <textarea-->
    <!--                      cdkTextareaAutosize-->
    <!--                      style="min-height: 50px; max-height: 200px;"-->
    <!--                      class=" bg-transparent resize-none w-100 fw-lighter crm-scroll text-black rounded-1 px-2"-->
    <!--                      placeholder="{{'enter_first_reply' | translate}}"-->
    <!--                      formControlName="text"-->
    <!--                    ></textarea>-->
    <!--                      <app-button btnType="icon" [disabled]="getReplyParams().length === 1" (onChangeClick)="deleteField({iParams})"><app-icon>delete</app-icon></app-button>-->
    <!--                  </div>-->
    <!--                  <div>-->
    <!--                    <app-checkbox formControlName="is_reply">{{'enable_auto_reply' | translate}}?</app-checkbox>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="d-flex justify-content-end gap-2">-->
    <!--          <app-button (onChangeClick)="saveReply()">{{ 'save' | translate }}</app-button>-->
    <!--          <app-button [btnType]="'icon'" (onChangeClick)="addReply()"><app-icon>add</app-icon></app-button>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </mat-card-content>-->

    @if (false) {
      <mat-card-footer class="bg-white rounded-2 m-3 p-4">
        <h5>{{ 'channel_settings' | translate }}</h5>
        <mat-divider></mat-divider>
        <div>
          <div class="d-flex gap-4 align-items-end flex-wrap">
            <app-dropdown
              class="flex-fill"
              style="max-width: 100%"
              label="Відкрита лінія"
              [items]="channels"
              [closeOnSelect]="true"
              [input]="channel_id"
              [bindValue]="'id'"
              (onValueChange)="onChangeChannel($event)"
            >
            </app-dropdown>
            <app-button (onChangeClick)="openDialogUpdateChannel()">{{ 'customize' | translate }}</app-button>
          </div>
          <!--        <div class="row">-->
          <!--          <div class="col-9">-->
          <!--            <app-dropdown-->
          <!--              label="Відкрита лінія"-->
          <!--              [items]="channels"-->
          <!--              [closeOnSelect]="true"-->
          <!--              [hidden-input]="channel_id"-->
          <!--              [bindValue]="'id'"-->
          <!--              (onValueChange)="onChangeChannel($event)"-->
          <!--            >-->
          <!--            </app-dropdown>-->
          <!--          </div>-->
          <!--          <div class="col-3">-->
          <!--            <div class="text-end">-->
          <!--              <div class="hidden">Налаштувати</div>-->
          <!--              <app-button (onChangeClick)="openDialogUpdateChannel()">Налаштувати</app-button>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
        </div>
      </mat-card-footer>
    }
  </mat-card>

  <app-integration-review [youtubeReviewLink]="'https://www.youtube.com/watch?v=P8z__xwMo18'"></app-integration-review>
</div>
